import { getConfig } from '@constants';

import { EStatEventType, EAppId } from '../../../../enums';
import { IStatParams } from '../../../../interfaces';
import { StatInstanceBase } from '../../StatInstanceBase';

import { IStatErrorParams } from './types';

export class StatShareApi extends StatInstanceBase {

	private getAppId(): EAppId {
		return getConfig().isMobile ? EAppId.SHARE_MOBILE : EAppId.SHARE;
	}

	async sendStat(params: IStatParams) {
		return super.sendStat({
			appId: this.getAppId(),
			...params,
		});
	}

	albumOpen() {
		void this.sendStat({
			action: EStatEventType.SHARING_ALBUM_OPEN,
		});
	}

	artistOpen() {
		void this.sendStat({
			action: EStatEventType.SHARING_ARTIST_OPEN,
		});
	}

	playlistOpen() {
		void this.sendStat({
			action: EStatEventType.SHARING_PLAYLIST_OPEN,
		});
	}

	trackOpen() {
		void this.sendStat({
			action: EStatEventType.SHARING_TRACK_OPEN,
		});
	}

	userOpen() {
		void this.sendStat({
			action: EStatEventType.SHARING_USER_OPEN,
		});
	}

	errorOpen({ error }: IStatErrorParams) {
		void this.sendStat({
			action: EStatEventType.SHARING_ERROR_OPEN,

			data0: error,
		});
	}

	play() {
		void this.sendStat({
			action: EStatEventType.SHARING_PLAY,
		});
	}

}
